import React from "react";
import ServicePage from "@/components/ServicePage";
import { laserData } from "@/data/services";

export default function Laser() {
    return <ServicePage data={laserData} />;
}
